import { render, staticRenderFns } from "./tenantDetail.vue?vue&type=template&id=9594466e&scoped=true"
import script from "./tenantDetail.vue?vue&type=script&lang=js"
export * from "./tenantDetail.vue?vue&type=script&lang=js"
import style0 from "./tenantDetail.vue?vue&type=style&index=0&id=9594466e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9594466e",
  null
  
)

export default component.exports